import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

function SiteHeader() {
  const { user, isLoggedIn, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    setIsDropdownOpen(false);
    await logout();
  };

  return (
    <header className="flex justify-between items-center px-4 md:px-8 py-3 bg-white border-b border-primary-300">
      <Link to={isLoggedIn ? "/dashboard" : "/"} className="flex items-center gap-2 hover:opacity-80 transition-opacity flex-shrink-0">
        <img src="/assets/logo.png" alt="My Video Gallery" className="w-7 h-7 flex-shrink-0" />
        <span className="text-lg md:text-xl font-bold text-primary-700 whitespace-nowrap">My Video Gallery</span>
      </Link>
      <nav className="flex items-center space-x-4 md:space-x-6">
        {isLoggedIn && user ? (
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center space-x-2 text-primary-500 hover:text-primary-600 font-medium focus:outline-none"
            >
              {user.profilePictureUrl && (
                <img
                  src={user.profilePictureUrl}
                  alt={user.name}
                  className="w-8 h-8 rounded-full border-2 border-primary-200 flex-shrink-0"
                  referrerPolicy="no-referrer"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                  }}
                />
              )}
              <span className="hidden sm:inline">{user.name}</span>
              <svg
                className={`w-4 h-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-primary-300">
                <Link
                  to="/dashboard"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-200 hover:text-primary-500"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Galleries
                </Link>
                <Link
                  to="/contact"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-200 hover:text-primary-500"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Contact
                </Link>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-800"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <Link to="/login" className="text-primary-500 hover:text-primary-600 font-medium">Login</Link>
        )}
      </nav>
    </header>
  );
}

export default SiteHeader;
